// dummy comment to trigger a rebuild, and another one ;)
import {GeocodeEarth} from './Hop/services/geoloc/geocode-earth';

let generatedId = 0;

Hop.defineModule('location', (root, param) => {
    const id = param.id || `generated-location-plugin-id-${generatedId++}`;
    const paramWithId = Object.assign({}, param, {id});

    const locationModuleInstance = new GeocodeEarth(root, paramWithId);
    Hop.storeObj(locationModuleInstance);

    root.addEventListener('hopModuleTrigger', (e) => e.detail.task === 'destroy' && Hop.destroyObj(id));

    return function destroy() {
        Hop.destroyObj(id);
    };
});
